/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Body.css";
import MediaQuery from "react-responsive";
export default function Banner({ links }) {
  return (
    <>
      <div className="banner">
        <Container>
          <Row className="banner-row">
            <Col sm={12} md={12} xl={5} xxl={5} lg={5}>
              <h3>Rachael Santos</h3>
              <img src={process.env.REACT_APP_THEMORTGAGEMILLENNIALINVESTOR_CDN_URL + "bannerul.webp"} className="bannerul"></img>
              <h1>
              The Mortgage <br/>Millennial Investor
              </h1>
              </Col>
              
           <Col sm={12} md={12} xl={2} xxl={2} lg={2}>
           <img src={process.env.REACT_APP_THEMORTGAGEMILLENNIALINVESTOR_CDN_URL + "MMimage.webp"} alt="" className="mortgagemillennial" />
           </Col>
            <Col sm={12} md={12} xl={5} xxl={5} lg={5}>
              <div className="rachaelimg">
              <img
                      src={process.env.REACT_APP_THEMORTGAGEMILLENNIALINVESTOR_CDN_URL + "Rachaelimg.webp"}
                      className="rachaelimg"
                      alt="Rachael Santos"/>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
